import { useEffect, type ReactNode } from 'react'
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom'
import { useAppSelector } from '@/app/hooks'
import { AppLayout } from '@/components/layout/AppLayout'
import { ConnectScreen } from '@/components/connection/ConnectScreen'
import { SettingsPage } from '@/components/connection/SettingsPage'
import { DashboardPage } from '@/components/dashboard/DashboardPage'
import { DealersPage } from '@/components/dealers/DealersPage'
import { PlansPage } from '@/components/plans/PlansPage'
import { ExceptionsPage } from '@/components/exceptions/ExceptionsPage'
import { Toaster } from '@/components/ui/Toaster'

export function App(): ReactNode {
  const configured = useAppSelector((s) => s.connection.configured)
  const theme = useAppSelector((s) => s.ui.theme)

  // The connect screen renders outside AppLayout, so keep the theme applied here
  // as well as inside the shell.
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }, [theme])

  return (
    <>
      {configured ? (
        // HashRouter, not BrowserRouter: the built bundle is meant to work when
        // opened straight from disk, where path routing has no server behind it.
        <HashRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="dealers" element={<DealersPage />} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="exceptions" element={<ExceptionsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </HashRouter>
      ) : (
        <ConnectScreen />
      )}
      <Toaster />
    </>
  )
}
